// 印尼语
module.exports = {
    public: {
        confirm: 'Konfirmasi',
        cancel: 'Batal',
        reset: 'Reset',
        search: 'Cari',
        RefreshSucceeded: 'Berhasil refresh',
        noMoreData: 'Tidak ada data lagi',
        pullingText: 'Tarik ke bawah untuk refresh…',
        ReleaseText: 'Lepas untuk refresh…',
        loadingText: 'Memuat…',
        noData: 'Tidak ada catatan',
        copyTxt: 'Salin',
        copySuccess: 'Berhasil disalin',
        amount: 'Jumlah',
        buy: 'Beli',
        orderNo: 'No Pesanan',
        selectLang: 'Pilih bahasa',
        light: 'Terang',
        dark: 'Gelap',
        All: 'Semua',
        DigitalCurrency: 'Kripto',
        foreignExchange: 'Forex',
        futures: 'Futures',
        stockIndex: 'Indeks',
        stock: 'Saham',
        BalanceNot: 'Saldo tidak cukup',
        optional: 'Favorit',
        market: 'Pasar',
        USDTcontract: 'Kontrak USDT',
        Fiatcurrencycontract: 'Kontrak Fiat',
        spot: 'Spot',
        secondContract: 'Kontrak Detik',
        emptyTxt: 'Tidak ada catatan',
        down: 'Scarica',
    },
    tabBar: {
        home: 'Beranda',
        market: 'Temukan',
        trade: 'Trading',
        heel: 'Mengatur uang',
        asset: 'Aset',
        my: 'Saya',
    },
    about: {
        title: 'Tentang Kami',
        version: 'Versi',
        about: 'Tentang',
        ProductIntroduction: 'Perkenalan Produk',
        Termofservice: 'Syarat Layanan',
        PrivacyAgreement: 'Kebijakan Privasi',
        Riskstatement: 'Peringatan Risiko',
        whitePaper: 'Buku Putih',
    },
    asset: {
        Overview: 'Ringkasan',
        contract: 'Kontrak',
        wallet: 'Dompet',
        Totalassetvaluation: 'Total estimasi aset',
        supportswithdrawal: 'Setiap aset yang Anda simpan dapat ditarik',
        Recharge: 'Deposit',
        Contractaccount: 'Akun Kontrak',
        Spotaccount: 'Akun Spot',
        Walletaccount: 'Akun Dompet',
        ValuationContractAssets: 'Estimasi aset kontrak',
        profitloss: 'Untung/Rugi',
        Transfer: 'Transfer',
        occupy: 'Mengunci',
        available: 'Tersedia',
        Viewallpositions: 'Lihat semua posisi',
        Valuationspotassets: 'Estimasi aset spot',
        Hidezerobalanceassets: 'Sembunyikan saldo nol',
        balance: 'Saldo',
        ValuationWalletAssets: 'Estimasi aset dompet',
        Withdrawal: 'Penarikan',
        Walletbalance: 'Saldo dompet',
        Cryptocurrencyrecharge: 'Deposit kripto',
        Fiatcurrencyrecharge: 'Deposit fiat',
        From: 'Dari',
        To: 'Ke',
        UsdtContractaccount: 'Akun Kontrak USDT',
        FiatContractaccount: 'Akun Kontrak Fiat',
        Currency: 'Mata uang',
        quantity: 'Jumlah',
        availablebalance: 'Saldo tersedia',
        Insufficientavailablebalance: 'Saldo tidak cukup',
        Transfersuccessful: 'Transfer berhasil',
        flashcash: 'Tukar cepat',
        flashcashsuccessful: 'Tukar cepat berhasil',
    },
    auth: {
        title: 'Verifikasi Identitas',
        gj: 'Kewarganegaraan',
        tipsgj: 'Pilih kewarganegaraan',
        userName: 'Nama asli',
        tips1: 'Masukkan nama asli',
        IDNumber: 'Nomor identitas',
        tips2: 'Masukkan nomor identitas',
        base: 'Verifikasi dasar',
        high: 'Verifikasi lanjutan',
        zmz: 'Foto depan identitas',
        bmz: 'Foto belakang identitas',
        tips3: 'Unggah foto depan',
        tips4: 'Unggah foto belakang',
        btn: 'Kirim',
        upbtn: 'Ubah identitas',
        subMsg: 'Berhasil dikirim, tunggu verifikasi',
        upMsg: 'Mengubah identitas akan memicu verifikasi ulang, lanjutkan?',
        wait: 'Dalam proses',
        fail: 'Verifikasi gagal',
        success: 'Verifikasi berhasil',
        cardType: 'Jenis identitas',
        idCard: 'KTP',
        passport: 'Paspor',
        driverlicense: 'SIM',
        AssetCertification: 'Sertifikasi aset',
        AccountType: 'Jenis akun',
        holdingamount: 'Jumlah kepemilikan',
        Accountscreenshot: 'Tangkapan layar akun',
        bankaccount: 'Akun bank',
        IRAaccount: 'Akun IRA',
        stockaccount: 'Akun saham',
        other: 'Lainnya',
        AccountTypetips: 'Silakan pilih jenis akun',
        Accountscreenshottips: 'Silakan unggah tangkapan layar akun',
    },
    activity: {
        inviteTxt: 'Setiap mengundang 1 teman, Anda akan mendapatkan {amount} USD, mendukung komisi hingga 3 level',
        invitebtn: 'Undang & Komisi',
        rechargeTxt: 'Ketika bawahan Anda melakukan deposit, Anda akan mendapatkan {amount}% komisi, mendukung komisi hingga 3 level',
        rechargebtn: 'Komisi Deposit',
        authTxt: 'Berhasil verifikasi identitas akan langsung mendapatkan {amount} USD',
        authbtn: 'Verifikasi Identitas',
        inviteRewardTxt: '<p><strong>Undang teman, mudah dapat 30 USD</strong></p><p><br></p><p>1. Tujuan Program</p><p><br></p><p>Sasaran: Pengguna baru dan lama dapat berpartisipasi, mendorong pengguna aktif mengundang teman mendaftar dan menyelesaikan tindakan tertentu untuk memperluas basis pengguna platform.</p><p>Inti: Melalui mekanisme referral, membantu pengguna baru bergabung cepat dan menciptakan pertumbuhan viral, sekaligus memberi reward nyata kepada pengundang untuk meningkatkan retensi dan loyalitas pengguna.</p><p><br></p><p>2. Durasi Program</p><p><br></p><p>20/05/2023 – Berlaku jangka panjang (akan dievaluasi atau dihentikan sesuai pengumuman).</p><p><br></p><p>3. Peserta</p><p><br></p><p>Pengguna yang sudah mendaftar platform dan verifikasi identitas dasar dapat menjadi pengundang (A).</p><p>Dihitung sah jika yang diundang (B) mendaftar baru lewat link atau kode undangan dan menyelesaikan verifikasi identitas.</p><p><br></p><p>4. Aturan Partisipasi</p><p><br></p><p>Cara undangan:</p><p>Pengundang (A) buka “Profil” → “Undang Teman” → salin link/kode undangan pribadi;</p><p>Bagikan kepada teman (B) untuk mendaftar via web atau aplikasi.</p><p><br></p><p>Persyaratan untuk yang diundang:</p><p>B harus menggunakan link atau kode A untuk pendaftaran pertama;</p><p>Dalam 7 hari harus verifikasi identitas dan mencapai deposit minimum (misalnya deposit pertama ≥ 1000 USD atau setara).</p><p><br></p><p>Struktur Tingkatan:</p><p>Program mendukung hingga 3 tingkat komisi.</p><p>Tingkat 1 (langsung): A mengundang langsung B.</p><p>Tingkat 2: B mengundang C, A dapat komisi tingkat kedua;</p><p>Tingkat 3: C mengundang D, A dapat komisi tingkat ketiga;</p><p>Di luar tingkat 3 (D mengundang E ke seterusnya) tidak dihitung untuk A.</p><p><br></p><p>5. Rincian Reward</p><p><br></p><p>Reward tingkat 1 (langsung):</p><p>Setelah B deposit dan verifikasi identitas, A menerima 30 USD.</p><p><br></p><p>Reward tingkat 2 (tidak langsung):</p><p>Jika B mengundang C dan C memenuhi syarat, A menerima 15 USD.</p><p><br></p><p>Reward tingkat 3:</p><p>Jika C mengundang D dan terpenuhi, A menerima 10 USD.</p><p><br></p><p>Metode Pencairan:</p><p>Sistem otomatis mendeteksi relasi tiga tingkat. Ketika downline memenuhi syarat, reward otomatis dikirim ke akun A dalam <strong>48 jam</strong>.</p><p><br></p><p>6. Contoh Alur:</p><p><br></p><p>A login ke GlobalEx → buka “Profil” → “Undang Teman” → salin link/kode;</p><p>A kirim ke B;</p><p>B klik link atau masukkan kode → mendaftar via email → verifikasi identitas dan deposit ≥ 1000 USD;</p><p>Setelah selesai, B hubungi layanan untuk klaim reward, sistem akan otomatis mengirim 30 USD ke A dalam 48 jam;</p><p>Jika B mengundang C yang memenuhi syarat, A dapat 15 USD; jika C mengundang D, A dapat 10 USD.</p><p><br></p><p>7. Kontrol Risiko & Catatan</p><p><br></p><p>Pencegahan Fraud:</p><p>Setiap nomor telepon/email hanya bisa diundang sekali; IP sama, ID, dll. akan diperiksa sistem risiko;</p><p>Untuk akun berkualitas rendah atau pendaftar massal dari perangkat/jaringan sama, akan ditinjau manual dan reward bisa dibatalkan;</p><p><br></p><p>Sanksi:</p><p>Jika ditemukan penyalahgunaan atau withdrawal ilegal melalui sistem invite, platform berhak membatalkan reward dan membekukan akun.</p><p><br></p>',
        rechargeRewardTxt: '<p><strong>Komisi deposit downline, profit langsung</strong></p><p><br></p><p><strong>1. Tujuan Program</strong></p><p><br></p><p>Penerima: Pengundang tingkat 1 (A) yang sudah verifikasi identitas dan sudah mengundang setidaknya satu downline (B, C, D); ketika mereka deposit di platform, A akan menerima persentase komisi sesuai ketentuan platform untuk mendorong perluasan jaringan dan aktivitas pengguna.</p><p><br></p><p>Inti: Melalui mekanisme “komisi atas deposit”, mengaitkan tindakan deposit pengguna baru dengan keuntungan pengundang, menciptakan siklus “undang – deposit – komisi – undang lagi”, guna mempertahankan dana dan meningkatkan aktivitas platform.</p><p><br></p><p><strong>2. Durasi Program</strong></p><p><br></p><p>Program berlangsung terus-menerus sejak 20/05/2023; persentase komisi atau durasi dapat disesuaikan dan diumumkan sebelumnya.</p><p><br></p><p><strong>3. Peserta</strong></p><p><br></p><p>Pengundang A: harus verifikasi identitas dan sudah mengundang minimal satu B dengan verifikasi selesai.</p><p><br></p><p>Downline B, C, D: adalah mereka yang diundang A atau downline A; saat mereka deposit, A mendapatkan komisi.</p><p><br></p><p><strong>4. Aturan Partisipasi</strong></p><p><br></p><p><strong>Struktur Tingkatan:</strong></p><p>Tingkat 1 (B langsung): B deposit ≥ 1000 USD → A mendapat 1%;</p><p>Tingkat 2 (C): C deposit ≥ 1000 USD → A mendapat 0,5%;</p><p>Tingkat 3 (D): D deposit ≥ 1000 USD → A mendapat 0,3%;</p><p>Hanya hingga tingkat 3.</p><p><br></p><p><strong>Saluran & Minimum Deposit:</strong></p><p>Semua metode deposit (fiat atau kripto) didukung, tapi setiap deposit harus ≥ 1000 USD untuk dihitung komisi;</p><p><br></p><p><strong>Persentase Komisi:</strong></p><p>Tingkat 1: 1,0% (misal B deposit 1000 USD → A dapat 10 USD);</p><p><br></p><p>Tingkat 2: 0,5% (C deposit 1000 USD → A dapat 5 USD);</p><p><br></p><p>Tingkat 3: 0,3% (D deposit 1000 USD → A dapat 3 USD);</p><p><br></p><p><strong>Penerimaan Komisi:</strong></p><p>Platform akan mengirim komisi dalam waktu 24 jam setelah deposit tercatat;</p><p>Pengguna dapat melihat sumber dan waktu komisi di “Dompet Saya” → “Detail Komisi”.</p><p><br></p><p>5. Contoh Alur:</p><p><br></p><p>A login APP → “Profil” → “Undang Teman” → salin link/kode;</p><p>A kirim ke B;</p><p>B daftar → verifikasi → deposit ≥ 1000 USD;</p><p>Setelah dana masuk, sistem otomatis hitung: total deposit × 1% = komisi untuk A; akan ditransfer dalam 24 jam;</p><p><br></p><p>Setelah B verifikasi, B bisa undang C; jika C deposit:</p><p>B dapat C deposit × 1%;</p><p>A dapat C deposit × 0,5%;</p><p><br></p><p>C undang D; jika D deposit:</p><p>C dapat D deposit × 1%;</p><p>B dapat D deposit × 0,5%;</p><p>A dapat D deposit × 0,3%;</p><p><br></p><p><strong>6. Kontrol Risiko & Catatan:</strong></p><p><br></p><p><strong>Pencegahan Abuse:</strong></p><p>Satu pengguna tidak boleh melakukan transaksi melingkar; platform memonitor deposit kecil berulang atau high‑frequency deposit w/d untuk validasi dan dapat membatalkan komisi;</p><p>Jika ada indikasi cepat withdrawal atau aktivitas frekuensi tinggi, sistem dapat membatalkan komisi;</p><p><br></p><p><strong>Kepatuhan:</strong></p><p>Jika platform mendeteksi risiko pencucian uang atau withdrawal ilegal, platform berhak membekukan komisi dan melapor ke regulator.</p><p><br></p>',
        authRewardTxt: '<p><strong>Verifikasi identitas, dapatkan 50 USD</strong></p><p><br></p><p>1. Tujuan Program</p><p><br></p><p>Sasaran: Pengguna baru dan lama (belum verifikasi sebelumnya) dapat berpartisipasi; bertujuan menarik pengguna untuk verifikasi identitas dan meningkatkan retensi, serta mendorong pengguna yang ragu karena proses panjang.</p><p>Inti: Melalui reward tunai langsung, dorong pengguna untuk verifikasi identitas, tingkatkan quality risk control dan cakupan KYC, pastikan operasi platform sesuai regulasi.</p><p><br></p><p>2. Durasi Program</p><p><br></p><p>20/05/2023 – Berlaku jangka panjang</p><p><br></p><p>3. Peserta</p><p><br></p><p>Pengguna baru: pertama kali mendaftar di GlobalEx dan verifikasi dalam durasi promo;</p><p>Pengguna lama: sudah daftar sebelumnya tetapi belum verifikasi; harus verifikasi selama program untuk mendapat reward;</p><p><br></p><p>4. Aturan Verifikasi</p><p><br></p><p>Persyaratan:</p><p>Unggah foto dokumen jelas (KTP/paspor/ijazah mengemudi) dua sisi dan foto semi badan memegang dokumen;</p><p>Proses face recognition memerlukan pencahayaan cukup, wajah tidak tertutup, memenuhi standar liveness;</p><p>Setelah submit, waktu verifikasi biasanya selesai dalam 24 jam;</p><p><br></p><p>5. Reward:</p><p>Setiap pengguna yang verifikasi identitas saat program berlangsung (baru atau lama) menerima 50 USD;</p><p><br></p><p>Pencairan:</p><p>Sistem mentransfer 50 USD ke akun kontrak fiat dalam 24 jam setelah verifikasi; setelah menyelesaikan 10 transaksi normal, bisa ditarik;</p><p><br></p><p>Jika data tidak lengkap atau gagal verifikasi, pengguna harus perbaiki dan verifikasi ulang untuk menerima reward;</p><p><br></p><p>6. Contoh Alur:</p><p><br></p><p>Pengguna login APP → “Verifikasi Identitas” → mulai proses;</p><p>Unggah foto KTP/paspor/SIM dua sisi;</p><p>Sistem mencocokkan otomatis; jika gagal, ikuti instruksi untuk ulangi;</p><p>Setelah disetujui, sistem transfer 50 USD ke akun kontrak fiat dalam 24 jam;</p><p><br></p><p>7. Kontrol Risiko & Catatan:</p><p><br></p><p><strong>Pencegahan Fraud:</strong></p><p>Satu dokumen hanya bisa dapat reward sekali; jika dari IP/perangkat sama unggah banyak dokumen, sistem akan kendalikan atau tolak;</p><p>Jika ada bukti dokumen palsu atau foto diedit, akun akan ditolak dan dibekukan;</p><p><br></p><p><strong>Perlindungan Data:</strong></p><p>Platform berkomitmen bahwa dokumen dan data face recognition hanya digunakan untuk KYC dan risk control, tidak akan dipublikasikan tanpa izin;</p><p>Setelah verifikasi, dokumen dan video dienkripsi dan disimpan sesuai regulasi;</p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: 'Riwayat Keuangan',
        audit: 'Menunggu verifikasi',
        success: 'Berhasil',
        refuse: 'Ditolak',
        recharge: 'Deposit',
        recharge_currency: 'Deposit Kripto',
        recharge_legal: 'Deposit Fiat',
        withdrawal: 'Penarikan',
        withdrawal_currency: 'Penarikan Kripto',
        cancel_withdrawal_currency: 'Batal tarik kripto',
        withdrawal_legal: 'Penarikan Fiat',
        cancel_withdrawal_legal: 'Batal tarik fiat',
        transfer: 'Transfer',
        usdt_contract_wallet: 'Kontrak USDT → Dompet',
        legal_contract_wallet: 'Kontrak Fiat → Dompet',
        coin_currency_wallet: 'Spot → Dompet',
        wallet_usdt_contract: 'Dompet → Kontrak USDT',
        wallet_legal_contract: 'Dompet → Kontrak Fiat',
        wallet_coin_currency: 'Dompet → Spot',
        finance_wallet: 'Keuangan → Dompet',
        wallet_finance: 'Dompet → Keuangan',
        usdt_contract_currency: 'Kontrak USDT → Spot',
        finance_currency: 'Keuangan → Spot',
        currency_usdt_contract: 'Spot → Kontrak USDT',
        currency_finance: 'Spot → Keuangan',
        legal_contract_currency: 'Kontrak fiat → Spot',
        currency_legal_contract: 'Spot → Kontrak fiat',
        recharge_reward: 'Komisi isi ulang dari bawahan',
        auth_reward: 'Hadiah verifikasi identitas',
        flashcash: 'Tukar cepat',
        trade: 'Trading',
        create_order: 'Buat pesanan',
        settlement_order: 'Penyelesaian pesanan',
        cancel_order: 'Batal pesanan',
        finance_return: 'Pengembalian pokok investasi',
        finance_income: 'Keuntungan investasi',
        other: 'Lainnya',
        commission_transfer: 'Komisi masuk',
        platform_gift: 'Bonus platform',
        system_regulation: 'Perubahan saldo',
        freeze_thaw: 'Freeze or thaw',
        c2c_create_order: 'C2C Buat pesanan',
        c2c_cancel_order: 'C2C Batal pesanan',
        Currency: 'Mata uang',
        type: 'Tipe',
        SelectCurrency: 'Pilih mata uang',
        SelectType: 'Pilih tipe',
        SelectDate: 'Pilih tanggal',
        to: 'ke',
        Contractfunds: 'Dana Kontrak',
        Spotfunds: 'Dana Spot',
        Walletfunds: 'Dana Dompet',
        RechargeRecord: 'Riwayat Deposit',
        WithdrawalRecord: 'Riwayat Penarikan',
        virtualcoin: 'Kripto',
        Legaltender: 'Fiat',
    },
    c2c: {
        limit: 'Batas',
        available: 'Tersedia',
        price: 'Harga satuan',
        needpay: 'Anda harus membayar',
        willreceive: 'Anda akan menerima',
        Insufficientlimit: 'Batas tidak mencukupi',
        Exceedinglimit: 'Melebihi batas',
        Exceedingavailable: 'Melebihi jumlah tersedia',
        balance: 'Saldo',
        InsufficientBalance: 'Saldo tidak mencukupi',
        OrderHistory: 'Riwayat Pesanan',
        quantity: 'Kuantitas',
        amountmoney: 'Jumlah uang',
        OrderNo: 'Nomor Pesanan',
        inprogress: 'Sedang berlangsung',
        Completed: 'Selesai',
        Cancelled: 'Dibatalkan',
        all: 'Semua',
        chat: 'Obrolan',
        picture: '[Gambar]',
        Read: 'Dibaca',
        Unread: 'Belum dibaca',
        inputTips: 'Masukkan pesan Anda di sini',
        send: 'Kirim',
    },
    common: {
        title: 'Semua fitur',
        Depositcoins: 'Deposit Kripto',
        Rechargefiatcurrency: 'Deposit Fiat',
        Withdraw: 'Penarikan',
        documentation: 'Mengatur uang',
        Activecenter: 'Pusat Aktivitas',
        Invitationforrebate: 'Undang & Dapat Komisi',
        Detailsoffunds: 'Riwayat Dana',
        Positiondetails: 'Detail Posisi',
        Notice: 'Informasi',
        Aboutus: 'Tentang Kami',
        helpcenter: 'Pusat Bantuan',
        customer: 'CS',
        Cryptocurrencywithdrawal: 'Tarik Kripto',
        Fiatmoneywithdrawal: 'Tarik Fiat',
    },
    forgotPass: {
        title: 'Reset Kata Sandi',
        btn: 'Konfirmasi',
        Password: 'Kata sandi baru',
        placeholder: 'Masukkan kata sandi baru',
        success: 'Berhasil diatur',
    },
    finance: {
        financeAssetAmount: 'Estimasi Aset Keuangan',
        financeAccount: 'Akun Keuangan',
        financefund: 'Dana Keuangan',
        financeProduct: 'Produk Keuangan',
        Applynow: 'Ajukan Sekarang',
        term: 'Jangka Waktu',
        investment: 'Jumlah Investasi',
        Mininvestment: 'Investasi Minimum',
        Maxinvestment: 'Jumlah investasi maksimum',
        buyNum: 'Jumlah pembelian',
        Myincome: 'Pendapatan Saya',
        Dailyearnings: 'Pendapatan Harian',
        yieldmaturity: 'Pendapatan Saat Jatuh Tempo',
        timeaxis: 'Garis Waktu',
        Subscriptiondate: 'Tanggal Pembelian',
        valuedate: 'Tanggal Mulai Bunga',
        duedate: 'Tanggal Jatuh Tempo',
        Receiptdate: 'Tanggal Penerimaan Dana',
        day: 'Hari',
        financeOrderList: 'Riwayat Keuangan',
        interestrate: 'kadar bunga',
        Revenueamount: 'Jumlah Pendapatan',
        Settlementamount: 'Jumlah Penyelesaian',
        regularly: 'Berjangka',
        eecurrent: 'Tidak berjangka',
        redemption: 'Penebusan',
        redemptionTips: 'Konfirmasi penebusan produk keuangan ini',
        loan: 'Pinjaman',
        LoanRange: 'Rentang pinjaman',
        LoanAmount: 'Jumlah pinjaman',
        loanTerm: 'Jangka waktu pinjaman',
        Dailyinterestrate: 'Suku bunga harian',
        Totalinterest: 'Total bunga',
        Repaymentmethod: 'Metode pembayaran',
        Repaymentofmaturity: 'Pelunasan pokok dan bunga sekaligus saat jatuh tempo',
        Estimatedreturn: 'Perkiraan jumlah yang harus dibayar',
        Ihavereadandagree: 'Saya telah membaca dan menyetujui',
        LoanAgreement: 'Perjanjian pinjaman',
        Immediatelymoney: 'Pinjam sekarang',
        Minimumloanamount: 'Jumlah pinjaman minimum',
        Maximumloanamount: 'Jumlah pinjaman maksimum',
        Applicationsuccessfulreview: 'Pengajuan berhasil, menunggu peninjauan sistem',
        Loanrecords: 'Catatan pinjaman',
        Pendingreview: 'Menunggu peninjauan',
        issued: 'Telah dicairkan',
        Repaid: 'Telah dibayar',
        Rejected: 'Ditolak',
        LoanDate: 'Tanggal pinjaman',
        AmountDue: 'Jumlah yang harus dibayar',
        repayment: 'Pembayaran',
        homeAddress: 'Alamat rumah lengkap',
        homeAddressTips: 'Silakan masukkan alamat rumah lengkap',
        emergencyContact: 'Kontak darurat',
        emergencyContactTips: 'Silakan masukkan kontak darurat',
        emergencyPhone: 'Nomor ponsel kontak darurat',
        emergencyPhoneTips: 'Silakan masukkan nomor ponsel kontak darurat',
        emergencyEmail: 'Email kontak darurat',
        emergencyEmailTips: 'Silakan masukkan email kontak darurat',
        isHouse: 'Apakah Anda memiliki properti sendiri',
        houseImg: 'Jika memiliki properti, silakan unggah bukti kepemilikan properti',
        certImg: 'Bagian depan dokumen (KTP/Paspor/SIM)',
        certImgTips: 'Silakan unggah bagian depan dokumen (KTP/Paspor/SIM)',
        certBackImg: 'Bagian belakang dokumen (KTP/Paspor/SIM)',
        certBackImgTips: 'Silakan unggah bagian belakang dokumen (KTP/Paspor/SIM)',
        trustImg: 'Tangkapan layar skor kredit',
        trustImgTips: 'Silakan unggah tangkapan layar skor kredit',
        yesTxt: 'Ya',
        noTxt: 'Tidak',
        EstimatedReturn: 'Lợi nhuận dự kiến',
        seeDetail: 'Xem chi tiết',
        orderDetails: 'Chi tiết đơn hàng',
        simFinanceTips: 'Silakan beralih ke akun nyata untuk menggunakan fitur investasi',
    },
    heel: {
        tips: 'Segera hadir~',
    },
    home: {
        optional: 'Favorit',
        HotList: 'Trending',
        more: 'Lebih banyak',
        Welcomeback: 'Selamat datang kembali',
        loginBtn: 'Masuk',
        CompleteAuth: 'Selesaikan verifikasi identitas untuk membuka semua layanan',
        authBtn: 'Verifikasi Sekarang',
        toptit1: 'Mulai trading kapan saja, di mana saja',
        toptit2: 'Investasi sekali klik, raih keuntungan dengan mudah!',
    },
    login: {
        title: 'Login',
        Account: 'Akun',
        Password: 'Kata sandi',
        btn: 'Masuk',
        placeholder: 'Masukkan nomor HP',
        placeholder1: 'Masukkan kata sandi',
        ForgotPassword: 'Lupa kata sandi',
        noAccount: 'Belum punya akun?',
        Registration: 'Daftar',
        server: 'Hubungi CS',
        success: 'Berhasil masuk',
        checkedAgree: 'Harap setujui kebijakan privasi',
        rememberpassword: 'Ingat kata sandi',
        agreewith: 'Setuju',
        PrivacyAgreement: 'Kebijakan Privasi',
    },
    market: {
        product: 'Produk',
        Latestprice: 'Harga Terbaru',
        volume: 'Volume',
        ChangeRatio: 'Perubahan',
        Addoptional: 'Tambah Favorit',
        optional: 'Favorit',
        market: 'Pasar',
        Editselfselection: 'Edit Favorit',
        operate: 'Operasi',
        SelectAll: 'Pilih Semua',
        delete: 'Hapus',
        time: 'waktu',
    },
    position: {
        title: 'Detail Posisi',
        totalassets: 'Total Aset',
        profitloss: 'Untung/Rugi',
        Holdingassets: 'Aset Ditahan',
        margin: 'Margin',
        orderAmount: 'Jumlah Pesanan',
        availableassets: 'Aset Tersedia',
        product: 'Produk',
        direction: 'Arah',
        Entrustedprice: 'Harga Order',
        Entrustednum: 'Jumlah Order',
        Currentprice: 'Harga Saat Ini',
        Stoplossprice: 'Harga Stop Loss',
        stopSurplusPrice: 'Harga Take Profit',
        Leverageratio: 'Leverage',
        Entrustedtime: 'Waktu Order',
        orderno: 'Nomor Order',
        marketvalue: 'Nilai Pasar',
        SettlementPrice: 'Harga Penyelesaian',
        Settlementtime: 'Waktu Penyelesaian',
        Settakeprofitloss: 'Atur SL/TP',
        closeposition: 'Tutup Posisi',
        Position: 'Order Saat Ini',
        commission: 'Riwayat Order',
        Settlement: 'Riwayat Transaksi',
        Settingsuccessful: 'Berhasil Diatur',
        Confirmclosingorder: 'Konfirmasi Tutup Order',
        Closingsuccessfully: 'Berhasil Ditutup',
        cancelorder: 'Konfirmasi Batal Order',
        Cancelsuccessfully: 'Berhasil Dibatalkan',
        status: 'Status',
        changeRate: 'Biaya',
    },
    property: {
        title: 'Detail Aset',
        totalassets: 'Total Aset',
        profitloss: 'Untung/Rugi',
        Holdingassets: 'Aset Ditahan',
        margin: 'Margin',
        availableassets: 'Aset Tersedia',
        investmentportfolio: 'Portofolio Investasi',
        Recentincomesituation: 'Pendapatan Terbaru',
        Seemore: 'Lihat Lebih',
        IncomeDetails: 'Detail Pendapatan',
    },
    recharge: {
        mixAmount: 'Min. Deposit',
        subMsg: 'Berhasil, Tunggu Verifikasi',
        amountMsg: 'Masukkan Jumlah',
        VoucherMsg: 'Unggah Bukti Bayar',
        Depositcoins: 'Deposit Koin',
        Rechargecurrency: 'Mata Uang Deposit',
        RechargecurrencyTips: 'Deposit >200USDT, Cepat Masuk',
        Depositaddress: 'Alamat Deposit',
        Rechargetoaccount: 'Deposit ke Akun',
        Walletaccount: 'Akun Dompet',
        Rechargequantity: 'Jumlah Deposit',
        Paymentvoucher: 'Bukti Pembayaran',
        Youneedtorecharge: 'Anda Harus Deposit',
        Rechargenow: 'Deposit Sekarang',
        Rechargefiatcurrency: 'Deposit Fiat',
        Topupfiatcurrency: 'Isi Saldo Fiat',
        paymentcurrency: 'Mata Uang Bayar',
        paymentcurrencyTips: 'Deposit >200USD, Cepat Masuk',
        Fiatcontractaccount: 'Akun Kontrak Fiat',
        Rechargeamount: 'Jumlah Deposit',
        Youwillget: 'Anda Akan Dapat',
        network: 'Jaringan',
        notsupportedAddress: 'Alamat tidak didukung',
        selectaccount: 'Pilih akun',
    },
    register: {
        title: 'Daftar',
        send: 'Kirim Kode',
        Resend: 'Kirim Ulang',
        sendSuccess: 'Berhasil Dikirim',
        PhoneNumber: 'No. HP',
        Mailbox: 'Email',
        Captcha: 'Kode Verifikasi',
        Password: 'Kata Sandi',
        ConfirmPassword: 'Konfirmasi Sandi',
        PromoteCode: 'Kode Promo',
        OrgCode: 'Kode Institusi',
        btn: 'Daftar',
        placeholder0: 'Masukkan No. HP',
        placeholder1: 'Masukkan Kata Sandi',
        placeholder2: 'Konfirmasi Kata Sandi',
        placeholder3: 'Masukkan ID Rekomendasi',
        placeholder4: 'Masukkan Kode Verifikasi',
        placeholder5: 'Masukkan Email',
        emaiError: 'Format Email Salah',
        success: 'Berhasil Daftar',
        message: 'Sandi Min. 6 Karakter',
        message1: 'Konfirmasi Sandi Min. 6 Karakter',
        message2: 'Sandi Tidak Cocok',
        searchCountryMsg: 'Cari Negara/Kode',
        haveAccount: 'Sudah Punya Akun?',
        goLogin: 'Masuk',
        titleTips: 'Mulai dari Pendaftaran!',
        Invitationcode: 'Kode Undangan',
        Iagreewith: 'Dengan Mendaftar, Saya Setuju dengan ',
        and: 'dan',
    },
    safe: {
        SecuritySettings: 'Pengaturan Keamanan',
        Accountsecurity: 'Keamanan Akun',
        phone: 'HP',
        Notyetbound: 'Belum Terhubung',
        mailbox: 'Email',
        Loginpassword: 'Sandi Login',
        Fundcode: 'Sandi Dana',
        Settings: 'Atur',
        Withdrawaladdressmanagement: 'Manajemen Alamat Penarikan',
        Addwithdrawaladdress: 'Tambah Alamat',
        Withdrawalcurrency: 'Mata Uang Tarik',
        Withdrawaladdress: 'Alamat Tarik',
        WithdrawaladdressTips: 'Masukkan Alamat',
        WithdrawaladdressError: 'Silakan masukkan alamat penarikan yang valid',
        remark: 'Catatan',
        confirm: 'Konfirmasi',
        Addedsuccessfully: 'Berhasil Ditambahkan',
        Pleaseselectcurrency: 'Pilih Mata Uang',
        Bindmailbox: 'Hubungkan Email',
        Bindmobilephone: 'Hubungkan HP',
        ChangeLoginPassword: 'Ubah Sandi Login',
        Setfundpassword: 'Atur Sandi Dana',
        BindmailboxTips: 'Hubungkan Email Dulu?',
        Addnewaddress: 'Tambah Alamat Baru',
        Confirmdeleteaddress: 'Konfirmasi Hapus Alamat',
    },
    share: {
        title: 'Bagikan & Hasilkan',
        commission: 'Komisi',
        Commissionrecord: 'Riwayat Komisi',
        Commissiontransferout: 'Tarik Komisi',
        Transferoutrecord: 'Riwayat Penarikan',
        Invitefriends: 'Undang Teman',
        Invitationrecord: 'Riwayat Undangan',
        Commissioncommission: 'Persentase Komisi',
        ReferralCode: 'Kode Referral',
        Firstlevelmembers: 'Member Level 1',
        Secondlevelmembers: 'Member Level 2',
        Thirdlevelmembers: 'Member Level 3',
        Transferbalance: 'Pindah ke Saldo',
        Confirmtransferout: 'Konfirmasi Tarik',
        Transfersuccessful: 'Berhasil Ditarik',
        amount: 'Jumlah Penarikan',
        Transferfiaaccount: 'Transfer ke akun kontrak',
    },
    trade: {
        high: '24j Harga Tertinggi',
        low: '24j Harga Terendah',
        vol: '24j Volume',
        buy: 'Beli',
        sell: 'Jual',
        buyBtn: 'Beli',
        sellBtn: 'Jual',
        Present: 'Pasar',
        Limit: 'Limit',
        limitMsg: 'Harga',
        markPriceMsg: 'Harga Terbaik',
        num: 'Jumlah',
        zyzsSet: 'Atur TP/SL',
        zyPrice: 'Take Profit',
        zsPrice: 'Stop Loss',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'Posisi',
        Viewalltransactions: 'Lihat Semua Transaksi',
        product: 'Produk',
        direction: 'Arah',
        Entrustedprice: 'Harga Order',
        Entrustednum: 'Jumlah Order',
        Latestprice: 'Harga Terbaru',
        volume: 'Volume',
        ChangeRatio: 'Perubahan %',
        buyBtnConfirm: 'Konfirmasi Beli',
        sellBtnConfirm: 'Konfirmasi Jual',
        totalAmount: 'Jumlah',
        Margin: 'Margin',
        balance: 'Saldo',
        buyLimtMsg: 'Harga beli harus lebih rendah dari pasar',
        sellLimtMsg: 'Harga jual harus lebih tinggi dari pasar',
        putNummsg: 'Masukkan jumlah',
        putLimitPriceMsg: 'Masukkan harga limit',
        pleaseAuth: 'Verifikasi identitas dulu',
        orderSuccess: 'Transaksi Berhasil',
        Fullwarehouse: 'Cross',
        corkado: 'Bisa Beli',
        Kato: 'Buka Long',
        openable: 'Bisa Jual',
        Openempty: 'Buka Short',
        purchasable: 'Bisa Beli',
        vendibility: 'Bisa Jual',
        Orderconfirmation: 'Konfirmasi Order',
        Averageopeningprice: 'Harga Buka Rata-rata',
        Marketprice: 'Harga Pasar',
        Openingquantity: 'Jumlah Buka',
        Stoplossprice: 'Harga SL',
        stopSurplusPrice: 'Harga TP',
        Averageprice: 'Harga Rata-rata',
        buyLimtMsg2: 'Harga beli harus lebih rendah dari pasar',
        sellLimtMsg2: 'Harga jual harus lebih tinggi dari pasar',
        authTips: 'Verifikasi identitas dulu',
        profundity: 'Kedalaman',
        deal: 'Transaksi',
        contract: 'Kontrak',
        TradeNow: 'Trading Sekarang',
        CloseTime: 'Pasar tertutup',
        buyUp: 'Beli Naik',
        buyDown: 'Beli Turun',
        selectSeconds: 'Pilih waktu jatuh tempo',
        buyNums: 'Jumlah beli',
        minbuyNums: 'Pembelian minimum',
        incomeRates: 'Tingkat keuntungan',
        buySuccessTips: 'Berhasil membeli',
        secondNums: 'Detik',
        simulatedTrading: 'Perdagangan Simulasi',
    },
    upPassword: {
        title: 'Ubah Password',
        oldPassword: 'Password Lama',
        oldPasswordMsg: 'Masukkan Password Lama',
        newPassword: 'Password Baru',
        newPasswordMsg: 'Masukkan Password Baru',
        twoPassword: 'Konfirmasi Password',
        twoPasswordMsg: 'Masukkan Konfirmasi Password',
        twoinputMsg: 'Password tidak sama',
        passwordTypeMsg: 'Kata sandi harus terdiri dari 6 digit angka',
        submsg: 'Berhasil Diubah',
        btn: 'Konfirmasi',
    },
    user: {
        Avatarchange: 'Ubah Avatar',
        Replacesuccessfully: 'Berhasil Diganti',
        authenticated: 'Terverifikasi',
        Notcertifiedyet: 'Belum Verifikasi',
        Invitefriends: 'Undang Teman',
        Activecenter: 'Pusat Event',
        Identityauthentication: 'Verifikasi Identitas',
        Completedverification: 'Verifikasi Selesai',
        Tobeverified: 'Menunggu Verifikasi',
        SecuritySettings: 'Keamanan',
        Lang: 'Pilih Bahasa',
        changeTheme: 'Ganti Tema',
        helpcenter: 'Pusat Bantuan',
        Aboutus: 'Tentang Kami',
        out: 'Keluar',
        outmsg: 'Konfirmasi Keluar',
        trustscore: 'Skor kredit',
    },
    welcome: {
        title1: 'Likuiditas Pasar Terbaik',
        tips1: '99% order dieksekusi di harga terbaik',
        title2: 'Dipercaya 12 Tahun',
        tips2: 'Trading crypto aman di platform terpercaya',
        title3: 'Keuntungan VIP',
        tips3: 'Dapatkan diskon biaya trading, exchange, dan withdrawal',
        title4: '100,000 USDT Demo',
        tips4: 'Latihan trading tanpa risiko',
        bnt1: 'Daftar & Dapat 10 USDT',
        bnt2: 'Masuk',
    },
    with: {
        Withdrawcurrency: 'Tarik',
        currencyofwithdrawal: 'Mata Uang Tarik',
        Withdrawaladdress: 'Alamat Tarik',
        Addwithdrawaladdress: 'Tambah Alamat Tarik',
        Withdrawalquantity: 'Jumlah Tarik',
        availablebalance: 'Saldo Tersedia',
        WithdrawaladdressTips: 'Belum ada alamat tarik, atur sekarang?',
        selectWithdrawaladdress: 'Pilih Alamat Tarik',
        Insufficientavailablebalance: 'Saldo Tidak Cukup',
        Withdrawingfiatcurrency: 'Tarik Fiat',
        Withdrawaloffiatcurrency: 'Fiat Tarik',
        Currentbalance: 'Saldo Saat Ini',
        Currencyreceived: 'Mata Uang Diterima',
        WithdrawingfiatcurrencyTips: 'Tarik > 200USD, cepat cair',
        Withdrawalaccount: 'Akun Tarik',
        Fiatcontractaccount: 'Akun Kontrak Fiat',
        Withdrawalamount: 'Jumlah Tarik',
        Youneedwithdrawmoney: 'Anda perlu tarik',
        Youwillget: 'Anda akan terima',
        Withdrawimmediately: 'Tarik Sekarang',
        mixAmount: 'Min. tarik ',
        subMsg: 'Berhasil dikirim, tunggu verifikasi',
    },
}
